import $ from "jquery";

$(document).ready(function () {
    const scrollToWithHeader = (selector) => {
        if (selector === '#' || selector.startsWith('#!')) {
            return;
        }

        const target = $(selector);

        $('html, body').animate({
            scrollTop: (target.length === 0 ? 0 : target.offset().top) - headerHeight,
        }, 500);
    };

    const header = $('.help-shift-nav');
    const headerHeight = header.height() + parseInt(header.css('margin-top'));

    $(document).on('click', '.help-system__content a[href^="#"]', function (event) {
        event.preventDefault();

        scrollToWithHeader($.attr(this, 'href'));
    });

    if (window.location.hash.startsWith('#')) {
        scrollToWithHeader(window.location.hash);
    }
});
